import React, { useEffect, useState } from 'react'
import PrivateRoute from '../../../components/PrivateRoute'

import { Link } from 'react-router-dom'

import {
  Box,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
  ListItem,
  ListItemIcon,
  List,
  Typography,
  Divider,
  ListItemText,
  ListItemButton,
  Avatar,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  TextField,
  Alert,
  LinearProgress
} from '@mui/material'

import LaunchIcon from '@mui/icons-material/Launch'
import DeleteIcon from '@mui/icons-material/Delete'

import { useSelector, useDispatch } from 'react-redux'
import { getProfile, deleteProfile } from '../../../actions/userActions'
import Loading from '../../../components/Loading'

import ProfileSidebar from '../../../components/ProfileSidebar'

const Profile = () => {
  const [open, setOpen] = useState(false)
  const [password, setPassword] = useState('')
  const dispatch = useDispatch()
  const { profile, loading, error } = useSelector(state => state.userState)
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('md'))

  const deleteProfileForm = (e) => {
    e.preventDefault()
    dispatch(deleteProfile(password))
  }

  useEffect(() => {
    dispatch(getProfile())
  }, [])

  return (
    <PrivateRoute>
      {loading ? <Loading /> : (
        <Box sx={{ display: 'flex' }}>
          <ProfileSidebar page={1} />
          {profile && <Card sx={{ width: 1200, mt: 5, height: 'fit-content', mx: matches ? 'auto' : 0 }}>
            <CardContent>
              <ListItem sx={{ display: 'flex', alignItems: 'center' }}>
                <ListItemIcon>
                  <Avatar sx={{ bgcolor: '#1f6cfa' }}>{profile.name[0]}</Avatar>
                </ListItemIcon>
                <ListItemText secondary={profile.role}>
                  <Typography variant='h6'>{profile.name}</Typography>
                </ListItemText>
              </ListItem>
              <Divider sx={{ mb: 2 }} />
              {profile.playlists.length > 0 ? <Box>
                <Typography variant='h6' sx={{ pl: 2 }}>Recent playlists</Typography>
                <List>
                  {profile.playlists[0] && <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/playlists/${profile.playlists[0]._id}`}>
                    <ListItem sx={{ width: '100%' }} disablePadding>
                      <ListItemButton>
                        <ListItemText secondary={profile.playlists[0].isPublic ? 'Public' : 'Private'}>
                          <Typography variant='body1'>{profile.playlists[0].title}</Typography>
                        </ListItemText>
                        <ListItemIcon>
                          <LaunchIcon />
                        </ListItemIcon>
                      </ListItemButton>
                    </ListItem>
                  </Link>}
                  {profile.playlists[1] && <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/playlists/${profile.playlists[1]._id}`}>
                    <ListItem sx={{ width: '100%' }} disablePadding>
                      <ListItemButton>
                        <ListItemText secondary={profile.playlists[1].isPublic ? 'Public' : 'Private'}>
                          <Typography variant='body1'>{profile.playlists[1].title}</Typography>
                        </ListItemText>
                        <ListItemIcon>
                          <LaunchIcon />
                        </ListItemIcon>
                      </ListItemButton>
                    </ListItem>
                  </Link>}
                  {profile.playlists[2] && <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/playlists/${profile.playlists[2]._id}`}>
                    <ListItem sx={{ width: '100%' }} disablePadding>
                      <ListItemButton>
                        <ListItemText secondary={profile.playlists[2].isPublic ? 'Public' : 'Private'}>
                          <Typography variant='body1'>{profile.playlists[2].title}</Typography>
                        </ListItemText>
                        <ListItemIcon>
                          <LaunchIcon />
                        </ListItemIcon>
                      </ListItemButton>
                    </ListItem>
                  </Link>}
                  {profile.playlists[3] && <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/playlists/${profile.playlists[3]._id}`}>
                    <ListItem sx={{ width: '100%' }} disablePadding>
                      <ListItemButton>
                        <ListItemText secondary={profile.playlists[3].isPublic ? 'Public' : 'Private'}>
                          <Typography variant='body1'>{profile.playlists[3].title}</Typography>
                        </ListItemText>
                        <ListItemIcon>
                          <LaunchIcon />
                        </ListItemIcon>
                      </ListItemButton>
                    </ListItem>
                  </Link>}
                  {profile.playlists[4] && <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/playlists/${profile.playlists[4]._id}`}>
                    <ListItem sx={{ width: '100%' }} disablePadding>
                      <ListItemButton>
                        <ListItemText secondary={profile.playlists[4].isPublic ? 'Public' : 'Private'}>
                          <Typography variant='body1'>{profile.playlists[4].title}</Typography>
                        </ListItemText>
                        <ListItemIcon>
                          <LaunchIcon />
                        </ListItemIcon>
                      </ListItemButton>
                    </ListItem>
                  </Link>}
                </List>
              </Box> : <Typography sx={{ ml: 2 }}>No playlists yet</Typography>}

              <Button endIcon={<DeleteIcon />} variant='contained' color='secondary' sx={{ ml: 2, mt: 2 }} onClick={() => setOpen(true)}>Delete profile</Button>
              <Dialog open={open} onClose={() => setOpen(false)}>
                {loading && <LinearProgress />}
                <DialogTitle>Warning!</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Are you sure? This CANNOT be undone. All of your playlists, both public and private, will also be deleted.
                  </DialogContentText>
                  {error && <Alert severity='error' sx={{ mt: 2 }}>{error}</Alert>}
                  <form onSubmit={deleteProfileForm}>
                    <TextField
                      label='Password'
                      type='password'
                      fullWidth
                      sx={{ my: 3 }}
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                    />
                    <Button variant='contained' color='secondary' fullWidth type='submit'>Delete profile</Button>
                  </form>
                </DialogContent>
              </Dialog>
            </CardContent>
          </Card>}
        </Box>
      )}
    </PrivateRoute>
  )
}

export default Profile